import { ReactElement } from 'react';
import { EntityActions, EntityContext, useEntity } from 'components';
import type { CampaignDetails } from '../../campaign/types';
import { usePlannerActions } from './usePlannerActions';
import { useManagerActions } from './useManagerActions';
import { useRequestHandler } from '../useRequestHandler';
import { BlockDetails } from '../types';
import { Box } from '@ff-it/ui';

export function BlockActions({ campaign }: { campaign: CampaignDetails }): ReactElement {
  const requestHandler = useRequestHandler();
  const plannerActions = usePlannerActions();
  const managerActions = useManagerActions({
    campaign,
    fetcher: requestHandler,
  });
  const ctx = useEntity<BlockDetails>();

  /* FIXME: request handler has endpoint prepended */

  return (
    <Box>
      <EntityContext.Provider value={{ ...ctx, endpoint: '' }}>
        <EntityActions actions={managerActions} size="sm" ml="3" fetcher={requestHandler} />
        <EntityActions actions={plannerActions} size="sm" ml="3" fetcher={requestHandler} />
      </EntityContext.Provider>
    </Box>
  );
}
